'use es6';

const MAX_STRING_LENGTH = 2000;
const KEYS_TO_OMIT = [
  // added by IE
  'number',
  'description',

  // added by safari
  'line',
  'column',
];

/**
 * @description
 * Copied from https://git.hubteam.com/HubSpot/conversations-error-reporting/blob/master/static/js/error-reporting/getExtraErrorData.js
 *
 * Extract useful metadata from error actions provided that they are primitive values.
 * Strings are truncated at 2000 characters.
 * Mainly useful for parsing helpful data out of API failures.
 *
 * @param {Error} error A JavaScript Exception
 * @returns {Object} Additional data defined on the exception
 */
export function getExtraErrorData(error, options = {}) {
  if (!error) return null;

  const errorData = {};
  if (error.options) {
    errorData.request = {
      body: !options.sensitiveData ? error.options.data : 'redacted',
      query: error.options.query,
      method: error.options.method,
    };
  }

  const keys = Object.keys(error).filter((key) => !KEYS_TO_OMIT.includes(key));

  if (!keys.length) return null;

  return keys.reduce((acc, key) => {
    switch (typeof error[key]) {
      case 'boolean':
      case 'number': {
        acc[key] = error[key];
        break;
      }

      case 'string': {
        // truncate string error properties after the max length
        const suffix = error[key].length > MAX_STRING_LENGTH ? '...' : '';
        acc[key] = `${error[key].substr(0, MAX_STRING_LENGTH)}${suffix}`;
        break;
      }

      case 'function': {
        acc[key] = 'function() { /* Function removed */ }';
        break;
      }

      case 'object': {
        if (error[key] === null) {
          acc[key] = error[key];
        } else {
          acc[key] = '/* Object, Error, or Array removed */';
        }
        break;
      }

      default:
        break;
    }

    return acc;
  }, errorData);
}
